// extracted by mini-css-extract-plugin
export default {"details":"UX6LX9XKtC4F_529zb3A"};